import localforage from 'localforage';
import { createHash, createCipher, createDecipher } from 'crypto';

localforage.config({
  name: 'secure-store',
  version: 1.0
});

export const createStorage = (keyRef) => ({
  async getItem(key) {
    const raw = await localforage.getItem(key);
    if(raw) {
      const decipher = createDecipher('aes-192-gcm', keyRef.current);
      return decipher.update(raw, 'base64', 'utf8');
    }
  },
  async setItem(key, raw) {
    const cipher = createCipher('aes-192-gcm', keyRef.current);
    let encrypted = cipher.update(raw, 'utf8', 'base64');
    encrypted += cipher.final('base64')
    return localforage.setItem(key, encrypted)
  },
  async removeItem(key) {
    return localforage.removeItem(key)
  },
  async length(...etc) {
    return localforage.length(...etc);
  },
  async clear(...etc) {
    return localforage.clear(...etc);
  },
  async key(...etc) {
    return localforage.key(...etc);
  },
  async keys(...etc) {
    return localforage.keys(...etc);
  },
});